export const FIELD_LYCAN_MESSAGE_MAP = {
  'LAST_MINUTE': 'DISCOUNT_LAST_MINUTE',
  'EARLY_BIRD': 'DISCOUNT_EARLY_BIRD'
};

export const nestedDataField = 'pricing.visual.specialDiscounts';
